export default __webpack_public_path__ + "static/media/loading-img.ef41c683.svg";